/**
 * Ícone do Otto como componente React: a câmera com o documento e o ponto vermelho do registro.
 *
 * O traço **herda a cor do texto** (`currentColor`), então acompanha o tema e o estado do item onde estiver (ativo,
 * apagado, no escuro, no claro). O ponto vermelho é a única cor fixa (`#FF4D4F`), como na marca.
 *
 * Por que não o arquivo `otto-icone.svg` direto: ele traz `<style>svg{color:#0F1115}</style>`, que, colado inline na
 * página, vaza para **todos** os SVGs dela. O componente não tem `<style>`.
 *
 * Aceita as mesmas props de um ícone do Lucide (`className`), então serve como `icon` do item de menu. `strokeWidth`,
 * `fill` e `fillOpacity` chegam do item de menu ativo e são ignorados de propósito: o desenho tem traço e preenchimento
 * próprios.
 *
 * Anima ao passar o mouse (ou focar) no item de menu que o contém, como os outros ícones do menu: o ponto do registro dá uma
 * pulsada e as três linhas de texto se escrevem uma depois da outra. Precisa de um ancestral com a classe `group`; sem ele
 * o ícone fica parado. Com "reduzir movimento" nunca anima. As animações são `otto-dot` e `otto-line` (`tailwind.config.js`).
 */
const WRITE = 'group-hover:animate-otto-line group-focus-visible:animate-otto-line motion-reduce:animate-none [transform-box:fill-box] [transform-origin:0%_50%]';
const LINE_DELAYS = ['', '[animation-delay:.09s]', '[animation-delay:.18s]'];

export function OttoIcon({ className, strokeWidth: _strokeWidth, fill: _fill, fillOpacity: _fillOpacity, ...props }) {
    return (
        <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true" focusable="false" {...props}>
            <g transform="translate(-1 -1.5)" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 14H35L44 23V44A6 6 0 0 1 38 50H21L14 56.5V50A6 6 0 0 1 8 44V20A6 6 0 0 1 14 14Z" />
                <path d="M35 14V20A3 3 0 0 0 38 23H44" />
                <path d="M48 27.5L56 22.6C57 22 58 22.6 58 23.7V40.3C58 41.4 57 42 56 41.4L48 36.5Z" />
                <path data-otto-line="1" className={`${WRITE} ${LINE_DELAYS[0]}`} d="M22.5 30H36" />
                <path data-otto-line="2" className={`${WRITE} ${LINE_DELAYS[1]}`} d="M14.5 36.6H37" />
                <path data-otto-line="3" className={`${WRITE} ${LINE_DELAYS[2]}`} d="M14.5 43.2H27" />
                <circle
                    data-otto-dot="1"
                    className="group-hover:animate-otto-dot group-focus-visible:animate-otto-dot motion-reduce:animate-none [transform-box:fill-box] [transform-origin:center]"
                    cx="15.5"
                    cy="30"
                    r="3"
                    fill="#FF4D4F"
                    stroke="none"
                />
            </g>
        </svg>
    );
}

export default OttoIcon;
